__turbopack_context__.v({
  "root": "styles-module-scss-module__5pBEtW__root",
  "widgetsContainer": "styles-module-scss-module__5pBEtW__widgetsContainer",
});
